import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_227: DocMigration = {
  maxSchemaVersion: "0.0.227",

  description: "Rename window vertical alignments and lateral offset props",
  apply(json: any) {
    function renameProp(setting: any, oldName: string, newName: string) {
      if (setting[oldName]) {
        setting[newName] = setting[oldName];
        delete setting[oldName];
      }
    }

    function renameDatumsAndProps(setting: any) {
      if (!setting) {
        return;
      }
      // rename vertical alignment value
      if (setting.verticalAlignment === "BO_WINDOW_HEADER") {
        setting.verticalAlignment = "TOP";
      } else if (setting.verticalAlignment === "TO_WINDOW_SILL") {
        setting.verticalAlignment = "BOTTOM";
      }
      // rename frame offset props
      renameProp(setting, "frameDatum", "lateralDatum");
      renameProp(setting, "frameAlignment", "lateralAlignment");
      renameProp(setting, "frameOffset", "lateralOffset");
    }

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const windowTypeId in setting.windowTypes) {
          const windowType = setting.windowTypes[windowTypeId];
          renameDatumsAndProps(windowType);
        }
      }
    }

    // update instances
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      renameDatumsAndProps(opening);
    }

    for (const openingId in json.gableOpenings) {
      const opening = json.gableOpenings[openingId];
      renameDatumsAndProps(opening);
    }

    for (const openingId in json.dormers) {
      const opening = json.dormers[openingId];
      renameDatumsAndProps(opening);
    }
    return json;
  },
};

export default migration_0_0_227;
